var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "quoteTool__header" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("h1", [_vm._v("Quote and Buy Business Water Services Online")]),
        _vm._v(" "),
        _vm.nav ? _c("step-progress") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }